import styled from "styled-components";

export const StyledLink = styled.div`
    font-size: 16px;
    line-height: 160%;
    margin-top: 50px;
    max-width: 350px;
    color: ${(props) => props.theme.colors.gray_1};
    /* The Sign up / Sign in link on the auth screens. Grey and underlined rather
       than brand-coloured: it is the quiet alternative to the form's own button,
       and on Peterpans the brand accent read as a second call to action. */
    a {
        color: ${(props) => props.theme.colors.gray_2};
        text-decoration: underline;
    }
`;

/** The quiet way out of an auth screen, on both Login and Sign Up. */
export const StyledReturnHomeLink = styled.div`
    margin-top: 24px;
    font-size: 14px;
    line-height: 160%;

    a {
        color: ${(props) => props.theme.colors.gray_3};
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`;

export const StyledForgotLink = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    a {
        color: ${(props) => props.theme.colors.gray_2};
        line-height: 160%;
        font-size: 14px;
    }
`;
